export default __webpack_public_path__ + "static/media/chikita-about.df6c3471.png";